
import React from 'react';
import { Trash } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { LoadSchedule, DayOfWeek } from '../types';
import DaySelector from './DaySelector';
import TimeRangeSelector from './TimeRangeSelector';

interface ScheduleItemProps {
  schedule: LoadSchedule;
  index: number;
  onRemove: (scheduleId: string) => void;
  onDayToggle: (scheduleId: string, day: DayOfWeek) => void;
  onTimeChange: (scheduleId: string, field: 'startTime' | 'endTime', value: string) => void;
  onToggleEnabled: (scheduleId: string) => void;
}

const ScheduleItem: React.FC<ScheduleItemProps> = ({ 
  schedule, 
  index, 
  onRemove, 
  onDayToggle, 
  onTimeChange, 
  onToggleEnabled 
}) => {
  return (
    <div className="p-4 border border-gray-200 dark:border-gray-800 rounded-lg bg-gray-50 dark:bg-gray-900">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <Checkbox
            id={`schedule-enabled-${schedule.id}`}
            checked={schedule.enabled}
            onCheckedChange={() => onToggleEnabled(schedule.id)}
          />
          <label
            htmlFor={`schedule-enabled-${schedule.id}`}
            className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-100"
          >
            Schedule {index + 1} {schedule.enabled ? '(Active)' : '(Inactive)'}
          </label>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onRemove(schedule.id)}
          className="text-red-500 hover:text-red-700 hover:bg-red-100 dark:hover:bg-red-900/20"
        >
          <Trash className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-4">
        <DaySelector 
          days={schedule.days} 
          scheduleId={schedule.id} 
          onDayToggle={onDayToggle} 
        />
        
        <TimeRangeSelector 
          startTime={schedule.startTime} 
          endTime={schedule.endTime} 
          scheduleId={schedule.id} 
          onTimeChange={onTimeChange} 
        />
      </div>
    </div>
  );
};

export default ScheduleItem;
